import { axios, API } from './config';

export const eventPackageTemplatesAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/event-package-templates`);
    return response.data;
  },
  create: async (data) => {
    const response = await axios.post(`${API}/event-package-templates`, data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await axios.put(`${API}/event-package-templates/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await axios.delete(`${API}/event-package-templates/${id}`);
    return response.data;
  }
};
